import { useEffect } from 'react';
import { shouldValidateLocalLibraryRefs, sanitizeMaestroQueueInStore, clearLocalLibraryValidationCache } from '../services/localLibraryRefValidator';
import { useRecentAlbumsStore } from '../store/recentAlbumsStore';
import { probeLocalLibraryHost } from '../services/localLibraryIpcGate';
import { clearCachedLocalAlbumDetails } from '../services/albumDetailCache';
import { useMaestroStore } from '../store/maestroStore';

/**
 * Re-validates Now Playing queue + Recently Played after cold start and library re-scan.
 */
export function useLibraryRefHydrationValidation() {
  useEffect(() => {
    let cancelled = false;

    const runValidation = async ({ clearAlbumCache = false } = {}) => {
      await probeLocalLibraryHost().catch(() => {});
      if (cancelled || !shouldValidateLocalLibraryRefs()) return;

      clearLocalLibraryValidationCache();
      if (clearAlbumCache) clearCachedLocalAlbumDetails();
      await sanitizeMaestroQueueInStore();

      const ps = useMaestroStore.getState().playbackState;
      if (ps === 'playing' || ps === 'loading') return;
      await useRecentAlbumsStore.getState().revalidateRecent?.();
    };

    const onLibraryChanged = (event) => {
      const reason = event?.detail?.reason;
      if (reason === 'scan-complete') {
        void runValidation({ clearAlbumCache: true });
      }
    };

    void runValidation();
    window.addEventListener('maestro:library:changed', onLibraryChanged);
    return () => {
      cancelled = true;
      window.removeEventListener('maestro:library:changed', onLibraryChanged);
    };
  }, []);
}
